export default {
feedback: {
  title: "Phản hồi",
  placeholder: "Để lại tin nhắn ({ contentLen }/1000 ký tự)",
  error: "Đây là thông báo lỗi",
  uploadLimit: "Giới hạn tải lên hình ảnh và video",
  send: "Gửi",
  tipTitle: "Giúp chúng tôi cải thiện trải nghiệm của bạn",
  desc1: "Bạn có thể gửi bất kỳ câu hỏi nào, và nếu được chấp nhận, bạn sẽ nhận được quà bất ngờ.",
  desc2: "Nếu không tiện qua website, bạn cũng có thể gửi qua email."
}
};
